function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 20.25C16.8325 20.25 20.75 16.3325 20.75 11.5C20.75 6.66751 16.8325 2.75 12 2.75C7.16751 2.75 3.25 6.66751 3.25 11.5C3.25 16.3325 7.16751 20.25 12 20.25ZM12 22.75C18.2132 22.75 23.25 17.7132 23.25 11.5C23.25 5.2868 18.2132 0.25 12 0.25C5.7868 0.25 0.75 5.2868 0.75 11.5C0.75 17.7132 5.7868 22.75 12 22.75ZM13.2625 6.8125C13.2625 7.50286 12.7029 8.0625 12.0125 8.0625H12C11.3097 8.0625 10.75 7.50286 10.75 6.8125C10.75 6.12214 11.3097 5.5625 12 5.5625H12.0125C12.7029 5.5625 13.2625 6.12214 13.2625 6.8125ZM10.7625 16.1875C10.7625 16.8779 11.3222 17.4375 12.0125 17.4375C12.7029 17.4375 13.2625 16.8779 13.2625 16.1875L13.2625 11.1875C13.2625 10.4971 12.7029 9.9375 12.0125 9.9375C11.3222 9.9375 10.7625 10.4971 10.7625 11.1875L10.7625 16.1875Z",
  fill: "#0173C6"
});

var SvgInfoDarkBlue = function SvgInfoDarkBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoDarkBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-dark-blue.30eb25d7.svg";
export { ForwardRef as ReactComponent };